import signedFetch from '../util/signedFetch.js';

export default () => signedFetch('searchOicOrgs', `${__API_BASE__}/org/oic/pending-orgs`, 'GET');
